import React, { useState } from "react";
import { useForm } from "react-hook-form";

import { CancelButton, FormButton } from "../../../../../components/Button";
import CustomDropdown from "../../../../../components/DropDown";
import { FormFieldset, Input } from "../../../../../components/Form";
import Loader from "../../../../../components/Loader";
import { IAddLead } from "../../Lead.props";
import useAddLead from "./useAddLead";

const AddLead: React.FC = () => {
  const {
    loading,
    formData,
    handleChange,
    handleSubmit,
    handleCancel,
    setInterestId,
    interest,
    interestId,
    services,
    serviceId,
    setServiceId,
    outputStatuses,
    outputStatusId,
    setOutputStatusId,
    platforms,
    platformId,
    setPlatformId,
    lookingFor,
    setLookingFor,
  } = useAddLead();
  const { handleSubmit: useFormSubmit } = useForm<IAddLead>();
  const lookingForOptions = [
    { id: "Individual", name: "Individual", type: "radio" },
    { id: "Agency", name: "Agency", type: "radio" },
  ];

  const personalFields = [
    { label: "Lead Name", name: "name", type: "text" },
    { label: "Company Name", name: "companyName", type: "text" },
    { label: "Email", name: "email", type: "email" },
    { label: "Phone", name: "phone", type: "tel" },
    { label: "Lead Web Link", name: "linkedin", type: "text" },
    { label: "CP LinkedIn Profile", name: "CPLinkedInProfile", type: "text" },
  ] as const;

  return (
    <div className="flex flex-col items-center w-full h-full pr-8 pl-6 ">
      <div className="bg-white shadow-md rounded-lg pt-6 pb-6 w-full ">
        <div className="border-b-2 w-[100%]">
          <h1 className="text-3xl mb-2 text-fontBlack ml-5">Add Lead</h1>
        </div>
        {loading && <Loader />}
        <form
          onSubmit={useFormSubmit(handleSubmit)}
          className="space-y-6 p-6 h-[75vh] overflow-y-scroll"
        >
          <FormFieldset Ftitle="Personal details">
            <div className="grid grid-cols-2 lg:grid-cols-5 md:grid-cols-3  m-4 gap-4">
              <CustomDropdown
                label="Interest"
                options={interest}
                defaultOptionId={interestId}
                setDefaultOptionId={setInterestId}
                displayProperty="name"
                value={interestId}
                style="flex items-center border h-12 rounded-lg shadow-none relative text-sm border-border text-fontColor w-full mb-4"
              />
              <CustomDropdown
                label="Services"
                options={services}
                defaultOptionId={serviceId}
                setDefaultOptionId={setServiceId}
                displayProperty="name"
                value={serviceId}
                style="flex items-center border h-12 rounded-lg shadow-none relative text-sm border-border text-fontColor w-full mb-4"
              />
              <CustomDropdown
                label="Output Status"
                options={outputStatuses}
                defaultOptionId={outputStatusId}
                setDefaultOptionId={setOutputStatusId}
                displayProperty="name"
                value={outputStatusId}
                style="flex items-center border h-12 rounded-lg shadow-none relative text-sm border-border text-fontColor w-full mb-4"
              />
              <CustomDropdown
                label="Platforms"
                options={platforms}
                defaultOptionId={platformId}
                setDefaultOptionId={setPlatformId}
                displayProperty="name"
                value={platformId}
                style="flex items-center border h-12 rounded-lg shadow-none relative text-sm border-border text-fontColor w-full mb-4"
              />
              {/* <CustomDropdown
                label="Looking For"
                options={lookingForOptions}
                defaultOptionId={lookingFor}
                setDefaultOptionId={setLookingFor}
                displayProperty="name"
                value={lookingFor}
                style="flex items-center border h-12 rounded-lg shadow-none relative text-sm border-border text-fontColor w-full mb-4"
              /> */}
              <div className="gap-2 flex flex-col justify-center">
              {lookingForOptions.map((option, index) => (
                <div className="space-x-2 items-start" key={index}>
                  <input
                    type="radio"
                    name="lookingFor"
                    value={option.name}
                    checked={lookingFor === option.name}
                    onChange={() => setLookingFor(option.name)}
                  />
                  <label>{option.name}</label>
                </div>
              ))}
              </div>
            </div>
            <div className="w-full md:flex">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 m-4 md:w-2/3">
                {personalFields.map((field) => (
                  <Input
                    key={field.name}
                    name={field.name}
                    label={field.label}
                    type={field.type}
                    value={formData[field.name]}
                    onChange={handleChange}
                  />
                ))}
              </div>
              <div className="md:w-1/3">
                <label className="text-fontBlack text-sm mb-2 flex">
                  Description:
                </label>
                <textarea
                  name="description"
                  id="description"
                  rows={13}
                  value={formData.description}
                  onChange={(e: any) => handleChange(e)}
                  className="mt-2 w-full text-gray-900 whitespace-pre-wrap bg-white p-3 rounded-md border border-gray-200"
                ></textarea>
              </div>
            </div>
          </FormFieldset>

          <div className="flex justify-center mt-6 ml-2 gap-3">
            <CancelButton
              className="py-2 px-4 h-[56px] w-[200.5px]"
              onClick={handleCancel}
              children="Cancel"
              type="button"
            />
            <FormButton
              className="py-2 px-4  h-[56px] w-[200.5px]"
              type="submit"
              children="ADD"
            />
          </div>
        </form>
      </div>
    </div>
  );
};
export default AddLead;
